'use client';

/**
 * `useSendOutcomeTokenGift` — delegates to the host's implementation.
 * See `./host-context.tsx` for the rationale.
 */
import { useGiftingHostContext } from './host-context.js';
export function useSendOutcomeTokenGift() {
  const {
    useSendOutcomeTokenGift: impl
  } = useGiftingHostContext();
  return impl();
}